import styled from "styled-components"
import { Link } from "gatsby"
import { className } from "./about.className"
import HomePageTitle from "../homePageTitle/homePageTitle"
import BlockContainer from "../blockContainer/blockContainer"
import { device } from "../mediaQuery/mediaQuery"

export const Container = styled(BlockContainer)`
  @media ${device.tablet} {
  }
  @media ${device.desktop} {
    :hover .${className.readMore} {
      background-color: white;
      color: #00a1cc;
    }
    :hover .${className.EnPTitle} {
      color: gold;
      font-weight: 700;
    }
    :hover .${className.EnPName} {
      list-style-type: disc;
    }
  }
`

export const Title = styled(HomePageTitle)`
  color: white;
`
export const ContentArea = styled.div`
  @media ${device.tablet} {
  }
  @media ${device.desktop} {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
export const HeadShotArea = styled.div`
  padding: 10px;
  box-sizing: border-box;
  @media ${device.tablet} {
    margin-bottom: 20px;
  }
  @media ${device.desktop} {
    width: 21%;
    margin-right: 3%;
  }
`
export const ContextArea = styled.div`
  @media ${device.tablet} {
  }
  @media ${device.desktop} {
    width: 50%;
    margin-right: 3%;
  }
`
export const Context = styled.p`
  margin-bottom: 20px;
  @media ${device.tablet} {
    font-size: 18px;
  }
  @media ${device.desktop} {
    font-size: 24px;
  }
`
export const ProjectArea = styled.div`
  padding-left: 20px;
  @media ${device.tablet} {
  }
  @media ${device.desktop} {
    width: 23%;
  }
`
export const EnPTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 5px;
  font-weight: bold;
  margin-left: -20px;
`
export const EnPName = styled.li`
  font-size: 18px;
  margin-bottom: 5px;
  list-style-type: circle;
`

export const ReadMore = styled.button`
  border: 2px solid white;
  background-color: #00a1cc;
  border-radius: 5px;
  margin: 0 5% 10px auto;
  padding: 10px;
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  display: block;
`
